import Image from 'app/Components/Shared/Image/image';
import React, {ChangeEvent, useState, useRef} from 'react';
import minisearch, {SearchResult} from 'minisearch';

import multiHighlightText from './multiHighlightText';
import useOnClickOutside from 'app/utilities/hooks/useOnClickOutside';
import classNames from 'classnames';

export interface TheCounterSearchItem {
  name: string;
  hints: string;
  href: string;
}

type TheCounterSearchProps = {
  index: minisearch<TheCounterSearchItem>;
  placeholder: string;
};

type MergedSearchResult = SearchResult & TheCounterSearchItem;

const TheCounterSearch = ({index, placeholder}: TheCounterSearchProps) => {
  const ref = useRef();
  const [outside, setOutside] = useState(true);
  const [term, setTerm] = useState('');
  const [results, setResults] = useState<MergedSearchResult[] | null>(null);
  // console.log(props);
  useOnClickOutside(ref, (outside) => setOutside(outside));

  const changeTerm = (event: ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setTerm(value);
    const eTerm = value.trim().toLowerCase();
    const results = eTerm == '' ? null : index.search(eTerm);
    setResults(results as MergedSearchResult[]);
  };

  const resetTerm = () => {
    setOutside(true);
    setResults(null);
    setTerm('');
  };

  const highlightSearchResult = (result: SearchResult) => {
    const text = result.name;
    return multiHighlightText({text, term: term.trim()});
  };

  return (
    <div className='TheCounterSearch'>
      <div className={classNames('TheCounterSearch__search', {outside})} ref={ref}>
        <div className='TheCounterSearch__search__input'>
          {/* <img className='TheCounterSearch__search__icon' src={require('./images/icons-search.svg')} /> */}
          <input placeholder={placeholder} type='text' onChange={changeTerm} value={term} />
          <Image className={classNames('TheCounterSearch__search__icon', {hidden: results == null})}
            src={require('./images/icons-reset.svg')}
            onClick={resetTerm} />
          {results != null && !outside && (
            <div className='TheCounterSearch__search__results'>
              <ul>
                {results.map((res, index) => (
                  <li key={index}>
                    <a href={res.href}>
                      <div className='title'>{highlightSearchResult(res)}</div>
                    </a>
                  </li>
                ))}
                {results.length == 0 && <li>לא נמצאו תוצאות</li>}
              </ul>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TheCounterSearch;
